import { render, staticRenderFns } from "./rfq-dlg-part-price.vue?vue&type=template&id=4aab8112"
import script from "./rfq-dlg-part-price.vue?vue&type=script&lang=js"
export * from "./rfq-dlg-part-price.vue?vue&type=script&lang=js"
import style0 from "./rfq-dlg-part-price.vue?vue&type=style&index=0&id=4aab8112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports